module.exports = __webpack_public_path__ + "img/domestic-2013-change.65ebe7fa.jpg";